export default function counterFactory() {
  let counter = 0;

  return {
    issue() {
      return ++counter;
    },
  };
}
